'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Button;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _joinClasses = _interopRequireDefault(require("../utils/join-classes"));
const _excluded = ["children", "onClick", "disabled", "small"];
function Button(_ref) {
  let {
      children,
      onClick,
      disabled,
      small
    } = _ref,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const output = /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({
    type: "button",
    disabled: disabled,
    className: (0, _joinClasses.default)('Button__root', disabled && 'Button__disabled', small && 'Button__small'),
    onClick: onClick
  }, props['data-test-id'] && {
    'data-test-id': props['data-test-id']
  }), children);
  return output;
}
